<script>
import ResourceList from '../../../lib/components/ResourceList.vue';
import Deletism from '../../../lib/components/ListActions/Deletism.vue';
import Undeletism from '../../../lib/components/ListActions/Undeletism.vue';
import ListAction from "../../../lib/components/ListActions/ListAction";

export default {
  components: {
    Deletism,
    ListAction,
    Undeletism,
  },
  extends: ResourceList,
};
</script>
